import axios from 'axios';
import { getApiKey } from './localStorage';

const BRANDFOLDER_URL = 'https://brandfolder.com/api/v4';

export const getOrganizationsWithContainers = () => {
  return axios
    .get(`${BRANDFOLDER_URL}/organizations`, {
      headers: {
        Authorization: `Bearer ${getApiKey()}`,
        'Content-Type': 'application/json'
      },
      params: {
        include: 'brandfolders,collections'
      }
    })
    .then(response => {
      return response.data.data.map(organization => {
        const brandfolders = organization.relationships.brandfolders.data.map(relationship => {
          return {
            ...response.data.included.find(include => include.type === 'brandfolders' && include.id === relationship.id),
            organization
          }
        });

        const collections = organization.relationships.collections.data.map((relationship) => {
          return {
            ...response.data.included.find(include => include.type === 'collections' && include.id === relationship.id),
            organization
          }
        });

        return {
          ...organization,
          brandfolders,
          collections
        }
      })
    });
};



// WEBPACK FOOTER //
// ./src/services/organization.js